import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=beb728a8&"
import script from "./helpCenter.vue?vue&type=script&lang=js&"
export * from "./helpCenter.vue?vue&type=script&lang=js&"
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=beb728a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports